export default __webpack_public_path__ + "static/media/September2008.b1449790.png";